import React from "react";

function cx(...arr) {
  return arr.filter(Boolean).join(" ");
}

export default function StatusPill({ value }) {
  const isReady = value === "พร้อมขาย";
  return (
    <span
      className={cx(
        "inline-flex items-center rounded-full px-3 py-[6px] text-xs font-medium",
        isReady ? "bg-[#30CA171A] text-[#30CA17]" : "bg-[#FF95001A] text-[#FF9500]"
      )}
    >
      {value}
    </span>
  );
}
